var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuItem',{attrs:{"name":_vm.meta.name,"to":_vm.meta.to}},[(_vm.meta.icon)?_c('Icon',{attrs:{"custom":_vm.meta.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.meta.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }